import Image from 'app/Components/Shared/Image/image';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { connect } from 'react-redux';
import { renderAuthButtons, text } from '../constants';
import { prepareSameWindowUrlWithNavigateTo } from 'app/utilities/StringHelpers/StringHelpers';
import Config from '../../../../Config';
import useScrollBlock from '../useScrollBlock';
import '../mobileHeader.scss';
import { checkLoginData } from 'app/Components/Page/SelfCarePage/Utilities';
import {
  setAnimate,
  setNavButtonsNew,
  setSelfCareData,
  setNavButtonsCurrent,
  setShowSelfCareMenu,
  setShowMenu
} from '../HeaderBlockSlice';
import MainMenu from './MainMenu/MainMenu';
import SelfCareMenu from './SelfCareMenu/SelfCareMenu';
import { set } from 'lodash';

const MobileHeader = (props) => {
  // const [blockScroll, allowScroll] = useScrollBlock();
  const isUserConnected = checkLoginData(props?.authentication?.loginData);

  const [userName, setUserName] = useState("לאזור האישי")
  const {
    headerData: {tabs, tabIndex, showMenu, showSelfCareMenu, hideNavigation},
    authentication,
    context,
    setAnimate,
    isBusinessNavigation,
    isBusinessNavigationMode,
    setNavButtonsNew,
    setShowMenu,
    setSelfCareData,
    setNavButtonsCurrent,
    setShowSelfCareMenu,
  } = props;

  const menuRef = useRef();
  const selfCareMenuRef = useRef();

  const toggleVisibility = (isMainMenu = false) => {
    var isVisible = isMainMenu ? showMenu : showSelfCareMenu;
    var isOtherVisible = isMainMenu ? showSelfCareMenu : showMenu;
    var setVisible = isMainMenu ? setShowMenu : setShowSelfCareMenu;
    var setOtherVisible = isMainMenu ? setShowSelfCareMenu : setShowMenu;
    setAnimate(isVisible ? 'animate-out' : 'animate-in');
    setVisible(!isVisible);
    if (isOtherVisible) {
      setOtherVisible(false);
    }
  };

  const getLogo = () => {
    if (tabs && tabIndex >= 0 && tabs[tabIndex]?.tabIconMobile?.expandedValue) {
      return Config.epiBaseUrl + tabs[tabIndex]?.tabIconMobile?.expandedValue?.url;
    }
    return '';
  };

  // useEffect(() => {
  //   if (showMenu || showSelfCareMenu) {
  //     blockScroll();
  //   } else {
  //     allowScroll();
  //   }
  // }, [showMenu, showSelfCareMenu]);


  useEffect(() => {
    let handler = (event) => {
      if (!menuRef.current?.contains(event.target)) {
        setShowMenu(false);
      }
      if (!selfCareMenuRef.current?.contains(event.target)) {
        setShowSelfCareMenu(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => {
      document.removeEventListener('mousedown', handler);
    };
  }, []);

  useEffect(() => {
    if (Array.isArray(tabs) && tabs.length > 0) {
      console.log('[MobileHeader] dispatch setNavButtonsCurrent');
      if (tabs[tabIndex]?.navButtonsCurrent?.value != null) setNavButtonsCurrent(tabs[tabIndex]?.navButtonsCurrent?.expandedValue);
      else setNavButtonsCurrent(null);

      if (tabs[tabIndex]?.navButtonsNew?.value != null) setNavButtonsNew(tabs[tabIndex]?.navButtonsNew?.expandedValue);
      else setNavButtonsNew(null);

      if (tabs[tabIndex]?.selfCareData?.value != null) setSelfCareData(tabs[tabIndex]?.selfCareData?.expandedValue[0]);
      else setSelfCareData(null);
    }
  }, [tabs, tabIndex, authentication, isBusinessNavigation, isBusinessNavigationMode]);

  return (
    <div className='mobile-header-container-main'>
      <div className={`${isBusinessNavigation || isBusinessNavigationMode ? 'business' : ''} mobile-header-container`}>
        <div className='mobile-container'>
          {hideNavigation ? (
            <button
              className='right-button-selfcare'
              onClick={() => {
                prepareSameWindowUrlWithNavigateTo(Config.lobbyUrl, context);
              }}>
              <Image className='home-icon' src={require('../images/home-icon.svg')} alt='home-icon' />
              <span>לאזור האישי</span>
            </button>
          ) : (
            <>
              <div ref={menuRef}>
                <MainMenu context={context} toggleVisibility={toggleVisibility} showMenu={showMenu} setShowMenu={setShowMenu} />
              </div>

              {/* LOGO */}
              <div className='mobile-container-logo'>
                <div
                  className='cellcom-logo'
                  onClick={() => {
                    context.navigateTo('/');
                  }}>
                  <Image src={getLogo()} />
                </div>
              </div>
            </>
          )}
          <div ref={selfCareMenuRef}>
            <SelfCareMenu
              toggleVisibility={toggleVisibility}
              showSelfCareMenu={showSelfCareMenu}
              setShowSelfCareMenu={setShowSelfCareMenu}
              context={context}
              isBusiness={isBusinessNavigation || isBusinessNavigationMode}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    headerData: state.Header,
    authentication: state.authentication,
  };
};

const mapDispatchToProps = {
  setAnimate,
  setNavButtonsNew,
  setSelfCareData,
  setNavButtonsCurrent,
  setShowSelfCareMenu,
  setShowMenu,
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileHeader);
